import React from 'react';
import styled from 'styled-components';

const CellExtend = styled.div`
  opacity: 0.1;
  background-color: #2b3d54;
  width: 100%;
  height: 100%;
  padding: 0px;
`;

const Cell = ({ onClick }) => (
  <CellExtend onClick={onClick ? () => onClick() : undefined} />
);

export default Cell;
